module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.109/css/toolsmenu.css"